import AbstractListView from '@UI/Store/AbstractListView';
import type FacilityTemplateOverrideView from '@UI/Store/DocumentTemplates/Views/TemplateAssignements/FacilityTemplateOverrideView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `organizationId` names the organization this catalogue belongs to.
 */
class FacilityTemplateOverridesListView extends AbstractListView<FacilityTemplateOverrideView> {
	readonly organizationId: number;

	constructor(list: readonly FacilityTemplateOverrideView[], organizationId: number) {
		super(list, 'FacilityTemplateOverridesListView');

		this.organizationId = organizationId;

		Object.freeze(this);
	}

	forDocumentTypeId(documentTypeId: number): readonly FacilityTemplateOverrideView[] {
		return this.list.filter((entry) => entry.documentTypeId === documentTypeId);
	}

	countForTemplate(templateId: number): number {
		return this.list.filter((entry) => entry.templateId === templateId).length;
	}
}

export default FacilityTemplateOverridesListView;
